import React, { ReactElement } from 'react';
import { LoginCallback } from '@okta/okta-react';

const OktaLoginCallback: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => (
  <LoginCallback {...props} />
));

export default OktaLoginCallback;
